export const validation = {
	name: {
		required: {
			value: true,
			message: 'Введите имя',
		},
		pattern: {
			value: /^[-а-яА-ЯёЁA-Za-z' ]{1,64}$/,
			message: 'Допустимы буквы, пробел и дефис',
		},
	},
	phone: {
		required: {
			value: true,
			message: 'Укажите номер телефона',
		},
		pattern: {
			value: /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/,
			message: 'Поле заполнено некорректно',
		},
	},
};
